import VendorQuotesLinesForm from '../../../../components/Purchasing/VendorQuotes/Lines/VendorQuotesLinesForm'
import React from 'react'
import {Modal} from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import {Row} from 'antd'

function VendorQuotesLinesModal(props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removing,
    submitting,
  } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Vendor Quotes Lines'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <Row>
        <VendorQuotesLinesForm ref={formRef} {...props} />
      </Row>
    </Modal>
  )
}

VendorQuotesLinesModal.propTypes = {}
VendorQuotesLinesModal.defaultProps = {}

export default VendorQuotesLinesModal
